// extracted by mini-css-extract-plugin
export default {"sketchbookPage":"SketchbookPage_sketchbookPage__LGI4F"};